import WoodenSpoon from './woodenspoon';

export default WoodenSpoon;
export { WoodenSpoon };